module.exports = __webpack_public_path__ + "static/media/ooh.4382c61a.svg";